module.exports = __webpack_public_path__ + "static/media/tumbleweed.eee72b73.gif";